<template>
  <div id="index">
    <!-- 头部 -->
    <com-header></com-header>
    <!-- 轮播图 -->
    <div
      class="_banner"
      @click="$router.push('/about')"
      v-if="$store.state.screenWidth > 960"
    >
      <el-carousel
        ref="carousel"
        height="100vh"
        arrow="never"
        autoplay
        :interval="5000"
        @mouseenter.native="autoplayHandler"
        @change="changeBanner"
      >
        <el-carousel-item v-for="item in banner" :key="item.id">
          <img :src="domain + '/bimwebsite/public' + item.thumbnail" alt="" />
          <div class="_info">
            <div v-if="item.txt">{{ item.txt }}</div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="_m_banner" v-else-if="$store.state.screenWidth <= 960">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="item in banner" :key="item.id">
          <img :src="domain + '/bimwebsite/public' + item.thumbnail" alt="" />
          <div class="_info">
            <div v-if="item.txt">{{ item.txt }}</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 中间大图 -->
    <!-- <div class="_big_img" @click="$router.push('/about')">
      <div class="_bg_img"></div>
      <div class="_info _info1">
        <span
          >依托自主研发项目管理平台
          <span class="_blue">主营</span>
          基于BIM技术医疗项目全生命周期咨询服务</span
        >
      </div>
      <div class="_info _info2">
        <span>城市医院建设，城市建筑运维 <span class="_blue">领域</span> </span>
      </div>
      <div class="_info _info3">
        <span>
          <span class="_blue">从事</span>
          BIM三维数字化设计、施工过程信息管理、全生命周期的运维软件开发、医疗建筑全过程咨询服务
        </span>
      </div>
    </div> -->
    <!-- 项目分布 -->
    <div class="_distribution">
      <!-- <ComTitle :name="'项目分布'" :english="'PROJECT DISTRIBUTION'" /> -->
      <div class="_map">
        <Distribution />
      </div>
    </div>
    <!-- 典型案例 -->
    <div class="_case" v-if="$store.state.screenWidth > 960">
      <!-- <ComTitle :name="'典型案例'" :english="'CLASSIC CASES'" /> -->
      <div class="_center">
        <div class="_header">
          <h5>典型案例</h5>
          <span>CLASSIC CASES</span>
          <div class="_btn_more" @click="$router.push('/project')">
            更多案例
          </div>
        </div>
        <ul class="_case_list">
          <li class="_case_item" v-for="item in caseCard" :key="item.id">
            <CaseCars :item="item" />
          </li>
        </ul>
      </div>
    </div>
    <div class="_m_case" v-else-if="$store.state.screenWidth <= 960">
      <div class="_header">
        <h5>典型案例</h5>
        <span>CLASSIC CASES</span>
      </div>
      <ul class="_case_list">
        <li class="_case_item" v-for="item in caseCard" :key="item.id">
          <CaseCars :item="item" />
        </li>
      </ul>
      <div class="_btn_more" @click="$router.push('/project')">更多案例</div>
    </div>
    <!-- LVP -->
    <div class="_lvp">
      <LvpVue />
    </div>
    <!-- opm -->
    <div class="_opm">
      <OpmVue />
    </div>
    <!-- 底部 -->
    <div class="_footer">
      <ComFooter />
    </div>
  </div>
</template>

<script>
import ComHeader from "../components/common/Header.vue";
import ComTitle from "../components/common/Title.vue";
import CaseCars from "../components/Index/CaseCard.vue";
import Distribution from "../components/Index/Distribution.vue";
import ComFooter from "../components/common/Footer.vue";
import LvpVue from "../components/Index/Lvp.vue";
import OpmVue from "../components/Index/Opm.vue";
import {
  bannerList as bannerListApi,
  projectList as projectListApi,
} from "../api";
export default {
  name: "Index",
  components: {
    ComHeader,
    ComTitle,
    CaseCars,
    Distribution,
    ComFooter,
    LvpVue,
    OpmVue,
  },
  data() {
    return {
      caseCard: [],
      banner: [],
      txtObj: [
        {
          txt: "做BIM 找彼盟",
        },
        {
          txt: "打造医院建筑BIM服务第一品牌",
        },
        {
          txt: "让建筑管理更简单",
        },
        {
          txt: "建筑全生命周期集成服务商",
        },
        {
          txt: "建筑BIM倡导者",
        },
      ],
    };
  },
  mounted() {
    this.init();
    setTimeout(() => {
      document.querySelectorAll(".el-carousel__item").length &&
        document
          .querySelectorAll(".el-carousel__item")[0]
          .children[1].classList.add("change_top");
    }, 1000);
  },
  methods: {
    init() {
      this.getBannerList();
      this.getProjectList();
    },
    getBannerList() {
      const _this = this;
      bannerListApi().then((res) => {
        if (res.code === 1) {
          _this.banner = res.data;
          for (let i = 0; i < _this.banner.length; i++) {
            for (let j = 0; j < _this.txtObj.length; j++) {
              if (i === j) {
                _this.banner[i].txt = _this.txtObj[j].txt;
                _this.banner[i].english = _this.txtObj[j].english;
              }
            }
          }
        }
      });
    },
    changeBanner(val) {
      // console.log(val);
      // console.log(document.querySelectorAll(".el-carousel__item").length);
      for (
        let i = 0;
        i < document.querySelectorAll(".el-carousel__item").length;
        i++
      ) {
        if (i === val) {
          document
            .querySelectorAll(".el-carousel__item")
            [val].children[1].classList.add("change_top");
        } else {
          document
            .querySelectorAll(".el-carousel__item")
            [i].children[1].classList.remove("change_top");
        }
      }
      document
        .querySelectorAll(".el-carousel__item")
        [val].children[1].classList.add("change_top");
    },
    getProjectList() {
      const _this = this;
      projectListApi({
        display: "1",
      }).then((res) => {
        if (res.code === 1) {
          _this.caseCard = res.data;
        }
      });
    },
    autoplayHandler() {
      this.$refs.carousel.handleMouseEnter = this.qq;
    },
    qq() {
      // console.log("修改成功");
    },
  },
};
</script>

<style lang="scss" scoped>
#index {
  ._banner {
    width: 100%;
    // height: 10.4rem;
    height: 100vh;
    /deep/ .el-carousel {
      .el-carousel__indicators.el-carousel__indicators--horizontal {
        .el-carousel__indicator.el-carousel__indicator--horizontal {
          .el-carousel__button {
            width: 0.63rem;
            height: 0.06rem;
            border-radius: 0.03rem;
            background-color: rgba(255, 255, 255, 0.3);
          }
          &.is-active {
            .el-carousel__button {
              background: #fff;
            }
          }
        }
      }
    }
    .el-carousel__item.is-animating {
      // transition: opacity 1s ease-in-out !important;
    }
    .el-carousel__item {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      .change_top {
        top: 4.38rem !important;
      }
      ._info {
        position: absolute;
        // top: 4.38rem;
        top: 14.38rem;
        left: 50%;
        transform: translateX(-50%);
        text-align: center;
        padding: 0.2rem 0.5rem;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/banner_txt.png")
          no-repeat;
        background-size: auto;
        transition: all 1.5s ease-in-out;
        div {
          font-size: 0.71rem;
          font-weight: bold;
          color: #fff;
          white-space: nowrap;
          z-index: 99;
          margin-bottom: 0.2rem;
          letter-spacing: 0.08rem;
        }
        span {
          font-size: 0.26rem;
          color: #fff;
          z-index: 99;
          font-weight: bold;
        }
      }
    }
  }
  ._m_banner {
    width: 100%;
    height: 4.22rem;
    margin-top: 0.7rem;
    .my-swipe {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
      ._info {
        position: absolute;
        // top: 1.18rem;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        text-align: center;
        padding: 0.2rem 0.5rem;
        background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/banner_txt.png")
          no-repeat;
        background-size: auto;
        div {
          font-size: 0.4rem;
          font-weight: bold;
          color: #fff;
          white-space: nowrap;
          z-index: 99;
          margin-bottom: 0.2rem;
          letter-spacing: 0.08rem;
        }
      }
    }
  }
  ._big_img {
    cursor: pointer;
    position: relative;
    width: 100%;
    height: 8.4rem;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/banner_02.png")
      no-repeat;
    background-size: cover;
    background-position: center;
    padding-top: 1.1rem;
    ._bg_img {
      width: 7.1rem;
      height: 5.95rem;
      margin: 0 auto;
      background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/banner_03.png")
        no-repeat;
      background-size: contain;
      background-position: center;
    }
    ._txt {
      position: absolute;
      color: #fff;
      font-size: 0.3rem;
    }
    ._txt1 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.48rem;
      color: #fff;
      // box-shadow: 0px 5px 5px 1px rgba(3, 28, 72, 0.18);
    }
    ._txt2 {
      top: 4%;
      left: 29.5%;
    }
    ._txt3 {
      top: 23.7%;
      left: 48.7%;
    }
    ._txt4 {
      top: 60%;
      left: 67%;
    }
    ._info {
      position: absolute;
      font-size: 0.2rem;
      color: #333;
      line-height: 0.28rem;
    }
    ._blue {
      font-size: 0.26rem;
      font-weight: bold;
      color: #3660aa;
    }
    ._info1 {
      top: 67%;
      left: 16%;
      width: 2.7rem;
    }
    ._info2 {
      top: 20%;
      left: 50%;
      transform: translateX(-50%);
      width: 3.2rem;
    }
    ._info3 {
      top: 70%;
      left: 70%;
      width: 3rem;
    }
  }
  ._case {
    width: 100%;
    height: 9.37rem;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/case_bg.jpg")
      no-repeat;
    background-position: center;
    background-size: cover;
    padding-top: 0.4rem;
    ._header {
      position: relative;
      width: 100%;
      text-align: center;
      font-size: 0.3rem;
      letter-spacing: 0.02rem;
      color: #fff;
      span {
        font-size: 0.18rem;
        color: #73859e;
        letter-spacing: 0.01rem;
      }
    }
    ._case_list {
      width: 100%;
      // height: 80vh;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 0.37rem;
      ._case_item {
        width: 4.65rem;
        height: 3.59rem;
        margin-bottom: 0.06rem;
      }
    }
    ._btn_more {
      position: absolute;
      right: 0;
      top: 0.37rem;
      cursor: pointer;
      width: 1rem;
      height: 0.32rem;
      line-height: 0.32rem;
      text-align: center;
      background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
        linear-gradient(#3660aa, #3660aa);
      border-radius: 0.02rem;
      font-size: 0.16rem;
      color: rgba(255, 255, 255, 0.8);
      &:hover {
        color: #fff;
      }
    }
  }
  ._m_case {
    width: 100%;
    // height: 9.37rem;
    background: url("https://bimeng.oss-cn-hangzhou.aliyuncs.com/oss/common/bmweb/images/mobile/index_03.png")
      no-repeat;
    background-position: center;
    background-size: cover;
    padding: 0.4rem 0.3rem 0.47rem;
    ._header {
      position: relative;
      width: 100%;
      text-align: center;
      font-size: 0.3rem;
      letter-spacing: 0.02rem;
      color: #fff;
      span {
        font-size: 0.18rem;
        color: #73859e;
        letter-spacing: 0.01rem;
      }
    }
    ._case_list {
      ._case_item {
        width: 6.91rem;
        height: 4.51rem;
        margin-bottom: 0.07rem;
      }
    }
    ._btn_more {
      width: 1.5rem;
      height: 0.4rem;
      line-height: 0.4rem;
      background-image: linear-gradient(0deg, #fe6022 0%, #f97d31 100%),
        linear-gradient(#3660aa, #3660aa);
      background-blend-mode: normal, normal;
      border-radius: 0.02rem;
      font-size: 0.2rem;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      margin: 0.31rem auto 0;
    }
  }
  ._distribution {
    ._map {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue